import React from 'react';




function ProgressBar(props) {
    const { bgcolor, completed,basebgcolor } = props;
  
    const containerStyles = {
      height: 6,
      width: '100%',
    // backgroundColor:'#d9d9d9',
      borderRadius: 50,
      backgroundColor: `${basebgcolor}`
   
    
    }
  
    const fillerStyles = {
      height: '100%',
      width: `${completed}%`,
      backgroundColor: bgcolor,
      borderRadius: 'inherit',
      textAlign: 'right'
    }
  
    const labelStyles = {
      padding: 5,
      color: 'white',
      fontWeight: 'bold'
    }
  
    return (
      <div style={containerStyles}>
        <div style={fillerStyles}>
            
          {/* <span style={labelStyles}>{`${completed}%`}</span> */}
        </div>
      </div>
    );
  };
  
  export default ProgressBar;
